import * as React from 'react';

type Handler = (event: MouseEvent) => void;

const handlers: Handler[] = [];

function listener(event: MouseEvent) {
  for (const listener of handlers) {
    listener(event);
  }
}

export function useOnClickOutside(elementRef: React.RefObject<HTMLElement | null>, callback: Handler, enabled = true) {
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;

  React.useEffect(() => {
    if (__BROWSER__ && enabled) {
      if (handlers.length === 0) {
        // Capture this event in case the click event itself removes the element
        window.addEventListener('click', listener, true);
      }

      function handler(event: MouseEvent) {
        if (elementRef.current && event.target instanceof Node && !elementRef.current.contains(event.target)) {
          callbackRef.current(event);
        }
      }

      handlers.push(handler);

      return () => {
        handlers.splice(handlers.indexOf(handler), 1);

        if (handlers.length === 0) {
          window.removeEventListener('click', listener, true);
        }
      };
    }
  }, [elementRef, enabled]);
}
